import React from "react";
import RecordsManager from "@/pages/admin/RecordsManager";

export default function Appointments() {
  return (
    <RecordsManager
      title="Appointment Requests"
      endpoint="appointments"
      nameField="patientName"
      columns={[
        { key: "patientName", label: "Patient" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "consultationType", label: "Type" },
        { key: "requestedDate", label: "Requested Date" },
      ]}
      detailFields={[
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "consultationType", label: "Consultation Type" },
        { key: "requestedDate", label: "Requested Date" },
        { key: "requestedTime", label: "Requested Time" },
        { key: "message", label: "Message" },
      ]}
    />
  );
}
